import React from 'react';
import { Route } from 'react-router-dom';

import DashboardLayout from '../components/dashboard/DashboardLayout';
import ProtectedRoute from './AuthenticatedRoutes';
import Booking from '../components/Hospitality/Booking/Booking';
import Enquiry from '../components/Hospitality/Enquiry/Enquiry';
import CheckIn from '../components/Hospitality/check-in/CheckIn';
import Dashboard from '../components/Hospitality/dashboard/Dashboard';
import Chatpage from '../components/chat/Chatpage';
import Complaint from '../components/Hospitality/Complaint/Complaint';
import RetailerComplaint from '../components/complaints/Complaints';
import Services from '../components/Hospitality/Services/Services';
import Feedback from '../components/Hospitality/Feedback/Feedback';
import Callback from '../components/Hospitality/callback/Callback';
import Vendors from '../components/vendors/Vendors';
import CreateOrUpdateVendor from '../components/vendors/CreateOrUpdateVendor';
import CreateComplaint from '../components/Hospitality/Complaint/CreateComplaint';
import Notification from '../notifications/Notification';

const HospitalitySidebarMenuNavigation = [
  {
    path: '/dashboard',
    element: (
      <DashboardLayout>
        <Dashboard />
      </DashboardLayout>
    ),
    key: 'dashboard'
  },
  {
    path: '/booking',
    element: (
      <DashboardLayout>
        <Booking />
      </DashboardLayout>
    ),
    key: 'booking'
  },
  {
    path: '/enquiry',
    element: (
      <DashboardLayout>
        <Enquiry />
      </DashboardLayout>
    ),
    key: 'enquiry'
  },
  {
    path: '/complaint',
    element: (
      <DashboardLayout>
        <Complaint />
      </DashboardLayout>
    ),
    key: 'complaint'
  },
  {
    path: '/complaints',
    element: (
      <DashboardLayout>
        <RetailerComplaint />
      </DashboardLayout>
    ),
    key: 'complaint'
  },
  {
    path: 'complaints/add-complaint',
    element: (
      <DashboardLayout>
        <CreateComplaint />
      </DashboardLayout>
    ),
    key: 'add-complaint'
  },
  {
    path: '/services',
    element: (
      <DashboardLayout>
        <Services />
      </DashboardLayout>
    ),
    key: 'services'
  },
  {
    path: '/feedback',
    element: (
      <DashboardLayout>
        <Feedback />
      </DashboardLayout>
    ),

    key: 'feedback'
  },
  {
    path: '/check-in',
    element: (
      <DashboardLayout>
        <CheckIn />
      </DashboardLayout>
    ),
    key: 'check-in'
  },
  {
    path: '/chat',
    element: (
      <DashboardLayout>
        <Chatpage />
      </DashboardLayout>
    ),
    key: 'chat'
  },
  {
    path: '/callback',
    element: (
      <DashboardLayout>
        <Callback />
      </DashboardLayout>
    ),
    key: 'callback'
  },
  {
    path: '/vendors',
    element: (
      <DashboardLayout>
        <Vendors />
      </DashboardLayout>
    ),
    key: 'vendors'
  },
  {
    path: '/vendors/add-vendor',
    element: (
      <DashboardLayout>
        <CreateOrUpdateVendor />
      </DashboardLayout>
    ),
    key: 'add-vendor'
  },
  {
    path: '/vendors/update-vendor/:id',
    element: (
      <DashboardLayout>
        <CreateOrUpdateVendor />
      </DashboardLayout>
    ),
    key: 'update-vendor'
  },
  {
    path: '/notifications',
    element: (
      <DashboardLayout>
        <Notification />
      </DashboardLayout>
    ),
    key: 'notifications'
  }
];

export default [
  <Route element={<ProtectedRoute />} key="protected-route">
    {HospitalitySidebarMenuNavigation.map((route) => (
      <Route key={route.key} path={route.path} element={route.element} />
    ))}
  </Route>
];
